(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7001],{

/***/ 33603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getTransitionName; }
/* harmony export */ });
/* harmony import */ var _config_provider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53124);

// ================== Collapse Motion ==================
const getCollapsedHeight = () => ({
  height: 0,
  opacity: 0
});
const getRealHeight = node => {
  const {
    scrollHeight
  } = node;
  return {
    height: scrollHeight,
    opacity: 1
  };
};
const getCurrentHeight = node => ({
  height: node ? node.offsetHeight : 0
});
const skipOpacityTransition = (_, event) => (event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === 'height';
const initCollapseMotion = (rootCls = _config_provider__WEBPACK_IMPORTED_MODULE_0__/* .defaultPrefixCls */ .Rf) => ({
  motionName: `${rootCls}-motion-collapse`,
  onAppearStart: getCollapsedHeight,
  onEnterStart: getCollapsedHeight,
  onAppearActive: getRealHeight,
  onEnterActive: getRealHeight,
  onLeaveStart: getCurrentHeight,
  onLeaveActive: getCollapsedHeight,
  onAppearEnd: skipOpacityTransition,
  onEnterEnd: skipOpacityTransition,
  onLeaveEnd: skipOpacityTransition,
  motionDeadline: 500
});
const _SelectPlacements = (/* unused pure expression or super */ null && (['bottomLeft', 'bottomRight', 'topLeft', 'topRight']));
const getTransitionName = (rootPrefixCls, motion, transitionName) => {
  if (transitionName !== undefined) {
    return transitionName;
  }
  return `${rootPrefixCls}-${motion}`;
};

/* harmony default export */ __webpack_exports__["Z"] = (initCollapseMotion);

/***/ }),

/***/ 10110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76745);
/* harmony import */ var _en_US__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24457);



const useLocale = (componentName, defaultLocale) => {
  const fullLocale = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_context__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
  const getLocale = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    var _a;
    const locale = defaultLocale || _en_US__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[componentName];
    const localeFromContext = (_a = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
  }, [componentName, defaultLocale, fullLocale]);
  const getLocaleCode = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    const localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale;
    // Had use LocaleProvide but didn't set locale
    if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) {
      return _en_US__WEBPACK_IMPORTED_MODULE_2__/* ["default"].locale */ .Z.locale;
    }
    return localeCode;
  }, [fullLocale]);
  return [getLocale, getLocaleCode];
};
/* harmony default export */ __webpack_exports__["Z"] = (useLocale);

/***/ }),

/***/ 80110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ genCompactItemStyle; }
/* harmony export */ });
// handle border collapse
function compactItemBorder(token, parentCls, options, prefixCls) {
  const {
    focusElCls,
    focus,
    borderElCls
  } = options;
  const childCombinator = borderElCls ? '> *' : '';
  const hoverEffects = ['hover', focus ? 'focus' : null, 'active'].filter(Boolean).map(n => `&:${n} ${childCombinator}`).join(',');
  return {
    [`&-item:not(${parentCls}-last-item)`]: {
      marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
    },
    [`&-item:not(${prefixCls}-status-success)`]: {
      zIndex: 2
    },
    '&-item': Object.assign(Object.assign({
      [hoverEffects]: {
        zIndex: 3
      }
    }, focusElCls ? {
      [`&${focusElCls}`]: {
        zIndex: 3
      }
    } : {}), {
      [`&[disabled] ${childCombinator}`]: {
        zIndex: 0
      }
    })
  };
}
// handle border-radius
function compactItemBorderRadius(prefixCls, parentCls, options) {
  const {
    borderElCls
  } = options;
  const childCombinator = borderElCls ? `> ${borderElCls}` : '';
  return {
    [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
      borderRadius: 0
    },
    [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
      [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
      [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function genCompactItemStyle(token, options = {
  focus: true
}) {
  const {
    componentCls
  } = token;
  const {
    componentCls: customizePrefixCls
  } = options;
  const mergedComponentCls = customizePrefixCls || componentCls;
  const compactCls = `${mergedComponentCls}-compact`;
  return {
    [compactCls]: Object.assign(Object.assign({}, compactItemBorder(token, compactCls, options, mergedComponentCls)), compactItemBorderRadius(mergedComponentCls, compactCls, options))
  };
}

/***/ }),

/***/ 95591:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide",
      function () {
        return __webpack_require__(2340);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68806);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11004);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61906);
/* harmony import */ var src_utils_apollo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18329);
/* harmony import */ var src_components_guide_Bottom__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72962);
/* harmony import */ var src_components_guide_Header__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98878);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88595);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_12__);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n        query {\n            tsafelyArticles(\n              filters: { tsafely_category: { name: { in: ["',
        '", "dashboards"] } } }\n              pagination: { page: ',
        ', pageSize: 20 }\n              sort: "updatedAt:desc"\n              locale: "',
        '"\n            ) {\n              data {\n                id\n                attributes {\n                  title\n                  slug\n                }\n              }\n              meta {\n                pagination {\n                  page\n                  pageSize\n                  pageCount\n                  total\n                }\n              }\n            }\n          }\n        '
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n          query {\n            tsafelyArticles(\n              filters: { tsafely_category: { name: { in: ["',
        '", "dashboards"] } } }\n              pagination: { page: ',
        ', pageSize: 20 }\n              sort: "updatedAt:desc"\n              locale: "',
        '"\n            ) {\n              data {\n                id\n                attributes {\n                  title\n                  slug\n                }\n              }\n              meta {\n                pagination {\n                  page\n                  pageSize\n                  pageCount\n                  total\n                }\n              }\n            }\n          }\n        '
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}












const Guide = ()=>{
    const { t , locale  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("common");
    const [searchText, setSearchText] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const [currentAndroid, setCurrentAndroid] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(1);
    const [currentIos, setCurrentIos] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(1);
    const [dataAndroid, setDataAndroid] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]);
    const [totalAndroid, setTotalAndroid] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(0);
    const [dataIos, setDataIos] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]);
    const [totalIos, setTotalIos] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(0);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const getAndroidData = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)((page)=>{
        // 历史「找 Google 账号」深链文章，不在首页展示
        const _arr = [
            "get-someones-google-account-and-password",
            "get-someones-google-account-and-password-jp",
            "google-konto-und-passwort-von-jemandem-erhalten",
            "obtenir-le-compte-et-le-mot-de-passe-google-de-quelquun",
            "obtener-la-cuenta-de-google-y-la-contrasena-de-alguien",
            "ottenere-qualcuno-account-e-password-google",
            "obter-a-conta-e-a-palavra-passe-de-alguem-no-google",
            "get-someones-google-account-and-password-kr",
            "referral-program-terms-and-conditions"
        ];
        let category = "android-guide";
        let local = "en";
        if (locale && locale != "en") {
            if (locale == "it-ch") {
                local = "it";
                category = category + "-it";
            } else if (locale == "jp") {
                local = "ja-JP";
                category = category + "-jp";
            } else if (locale == "kr") {
                local = "ko-KR";
                category = category + "-kr";
            } else {
                local = locale;
                category = category + "-" + locale;
            }
        }
        // android-guide 已空；实际指南在 dashboards（user-guide-android / back-up-android）
        (0,src_utils_apollo__WEBPACK_IMPORTED_MODULE_7__/* .logQuery */ .g)({
            query: (0,_apollo_client__WEBPACK_IMPORTED_MODULE_10__/* .gql */ .Ps)(_templateObject(), category, page, local)
        }).then((res)=>{
            const list = res.data.tsafelyArticles.data.filter((item)=>{
                const slug = item.attributes.slug || "";
                if (_arr.includes(slug)) return false;
                return slug.includes("android");
            });
            setDataAndroid(list.slice(0, 6));
            setTotalAndroid(list.length);
        });
    }, [
        locale
    ]);
    const getIosData = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)((page)=>{
        const _arr = [
            "get-someones-icloud-account-and-password",
            "get-someones-icloud-account-and-password-jp",
            "icloud-konto-und-passwort-von-jemandem-erhalten",
            "obtenir-le-compte-et-le-mot-de-passe-de-quelquun-sur-icloud",
            "conseguir-la-cuenta-y-contrasena-de-alguien-en-icloud",
            "ottenere-qualcuno-account-e-password-icloud",
            "obter-conta-e-senha-de-alguem-da-icloud",
            "get-someones-icloud-account-and-password-kr",
            "referral-program-terms-and-conditions"
        ];
        let category = "ios-guide";
        let local = "en";
        if (locale && locale != "en") {
            if (locale == "it-ch") {
                local = "it";
                category = category + "-it";
            } else if (locale == "jp") {
                local = "ja-JP";
                category = category + "-jp";
            } else if (locale == "kr") {
                local = "ko-KR";
                category = category + "-kr";
            } else {
                local = locale;
                category = category + "-" + locale;
            }
        }
        (0,src_utils_apollo__WEBPACK_IMPORTED_MODULE_7__/* .logQuery */ .g)({
            query: (0,_apollo_client__WEBPACK_IMPORTED_MODULE_10__/* .gql */ .Ps)(_templateObject1(), category, page, local)
        }).then((res)=>{
            const list = res.data.tsafelyArticles.data.filter((item)=>{
                const slug = item.attributes.slug || "";
                if (_arr.includes(slug)) return false;
                return slug.includes("ios") || slug.includes("iphone") || slug.includes("icloud");
            });
            setDataIos(list.slice(0, 6));
            setTotalIos(list.length);
        });
    }, [
        locale
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        getAndroidData(1);
        getIosData(1);
    }, [
        getAndroidData,
        getIosData
    ]);
    const onChangeAndorid = (page)=>{
        setCurrentAndroid(page);
        getAndroidData(page);
    };
    const onChangeIos = (page)=>{
        setCurrentIos(page);
        getIosData(page);
    };
    const onEnter = (event)=>{
        if (event.key === "Enter") {
            router.push("/guide/search?query=" + searchText);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_guide_Header__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "w-full h-[240px] Bxl:px-[16px] bg-[#1c1e53] border-t border-[rgb(118,118,120)] flex flex-col justify-center items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h1", {
                        className: "text-[26px] Bld:text-[22px] text-[#FFF] text-center font-[600]",
                        children: [
                            t("Welcome to Msafely Help Center"),
                            "!"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "w-[607px] Bld:w-full h-[44px] Bld:h-[40px] bg-[#FFF] border border-[rbg(121,121,121)] rounded-[41px] outline-none px-[24px] mt-[30px] flex items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: "/images/contacts/search.svg",
                                width: 20,
                                height: 0,
                                alt: "search"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                className: "ml-[10px] flex-1 outline-none text-[16px] placeholder:text-[rgb(129,129,135)]",
                                placeholder: t("Search"),
                                value: searchText,
                                onChange: (e)=>setSearchText(e.target.value),
                                onKeyPress: onEnter
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("main", {
                className: "w-full min-h-[calc(var(--vh)*100-620px)] Bld:min-h-[calc(var(--vh)*100-600px)] Bxl:px-[16px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "max-w-[1200px] mx-auto py-[40px] flex Bld:flex-col",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "flex-1 flex flex-col justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                            className: "text-[20px] Bld:text-[18px] font-[600]",
                                            children: t("User guide for Android")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "mt-[10px] flex flex-col w-[85%] Blds:Bxl:w-[90%] Bld:w-full",
                                            children: dataAndroid.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "py-[20px] border-b",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        href: "/guide/" + item.attributes.slug,
                                                        className: "text-[16px] Bld:text-[15px] text-[#222] hover:text-[#2a99ff] cursor-pointer",
                                                        children: item.attributes.title
                                                    })
                                                }, i))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().pagination), " mt-[30px]"),
                                    current: currentAndroid,
                                    pageSize: 6,
                                    total: totalAndroid,
                                    onChange: onChangeAndorid
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "flex-1 Bld:mt-[50px] flex flex-col justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                            className: "text-[20px] Bld:text-[18px] font-[600]",
                                            children: t("User guide for iPhoneiPad")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "mt-[10px] flex flex-col w-[85%] Blds:Bxl:w-[90%] Bld:w-full",
                                            children: dataIos.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "py-[20px] border-b",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        href: "/guide/" + item.attributes.slug,
                                                        className: "text-[16px] Bld:text-[15px] text-[#222] hover:text-[#2a99ff] cursor-pointer",
                                                        children: item.attributes.title
                                                    })
                                                }, i))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().pagination), " mt-[30px]"),
                                    current: currentIos,
                                    pageSize: 6,
                                    total: totalIos,
                                    onChange: onChangeIos
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_guide_Bottom__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Guide);


/***/ }),

/***/ 88595:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"article":"guide_article__cxmMw","pagination":"guide_pagination__uhlzl"};

/***/ }),

/***/ 5110:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = (function (element) {
  if (!element) {
    return false;
  }
  if (element instanceof Element) {
    if (element.offsetParent) {
      return true;
    }
    if (element.getBBox) {
      var _getBBox = element.getBBox(),
        width = _getBBox.width,
        height = _getBBox.height;
      if (width || height) {
        return true;
      }
    }
    if (element.getBoundingClientRect) {
      var _element$getBoundingC = element.getBoundingClientRect(),
        _width = _element$getBoundingC.width,
        _height = _element$getBoundingC.height;
      if (_width || _height) {
        return true;
      }
    }
  }
  return false;
});

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,1954,1033,8914,3368,1675,1664,3573,1004,2068,1709,9774,2888,179], function() { return __webpack_exec__(95591); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);